require("@tabler/core/src/js/tabler.js");

require("./bootstrap");

$(document).ready(function () {
    $(".delete-item").submit(function (event) {
        event.preventDefault();
        var currentForm = this;
        bootbox.confirm({
            message: "Er du sikker?",
            buttons: {
                confirm: {
                    label: "Ja",
                    className: "btn-danger",
                },
                cancel: {
                    label: "Nej",
                    className: "btn-light",
                },
            },
            callback: function (result) {
                if (result) {
                    currentForm.submit();
                }
            },
        });
    });


    $('form input[name=type]').change(function() {
        $(".hideable-inputs").hide();
        $(`#${$(this).val()}Input`).show();
    });
});
